export default __webpack_public_path__ + "resources/icons/n241-d468.png";